import React from 'react'
import Grid from '@mui/material/Grid'
import { IoMdCheckboxOutline } from 'react-icons/io'
import './BuildingAndProperty.scss'
import { objectHasAnyValue } from '../../../../../resources/Utils'

const Roofing = React.memo(({ roofingEntity }) => {
  const roofing = React.useMemo(() => roofingEntity, [roofingEntity])

  const hasRoofingEntity = React.useMemo(() => {
    return objectHasAnyValue(roofing)
  }, [roofing])

  return (
    <>
      {hasRoofingEntity &&
      (roofing.roof || (roofing.solarPanel && roofing.solarPanel.isChecked)) ? (
        <h2 className="section-title">Roofing</h2>
      ) : null}

      {hasRoofingEntity &&
      roofing.solarPanel &&
      roofing.solarPanel.isChecked &&
      roofing.solarPanel.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Solar Panel:
            {roofing.solarPanel.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {roofing.solarPanel.portion ? <>{`, ${roofing.solarPanel.portion}`}</> : null}
              </span>
            ) : (
              ''
            )}
          </label>

          {roofing.solarPanel.isChecked &&
          roofing.solarPanel.location &&
          roofing.solarPanel.location ? (
            <Grid className="section">
              <label className="main-title-label">
                Solar Panel Location:{' '}
                {roofing.solarPanel.location ? (
                  <span className="answer">{roofing.solarPanel.location}</span>
                ) : null}
              </label>
            </Grid>
          ) : null}
        </Grid>
      ) : null}

      {hasRoofingEntity && roofing.roof && roofing.roof && roofing.roof ? (
        <Grid className="section">
          <label className="main-title-label">Your roof is:</label>
          <Grid className="container-field">
            {roofing.roof.compositeShingles && roofing.roof.compositeShingles ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.compositeShingles ? ' Composite shingles' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.treatedWoodShingles && roofing.roof.treatedWoodShingles ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.treatedWoodShingles ? ' Treated wood shingles' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.untreatedWoodShingles && roofing.roof.untreatedWoodShingles ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.untreatedWoodShingles ? ' Untreated wood shingles' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.tileClay && roofing.roof.tileClay ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.tileClay ? ' Tile-Clay' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.tileCement && roofing.roof.tileCement ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.tileCement ? ' Tile-Cement' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.tileSlate && roofing.roof.tileSlate ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.tileSlate ? ' Tile-Slate' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.tileOther && roofing.roof.tileOther ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.tileOther ? ' Tile-Other' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.metal && roofing.roof.metal ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.metal ? ' Metal' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {roofing.roof.other && roofing.roof.other ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {roofing.roof.other ? ` Other: ${roofing.roof.other}` : ''}{' '}
                </label>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      ) : null}
    </>
  )
})

export default Roofing
